import './LmsTecResultAttendByClass.scss';
import * as S from '../scss/theme';
import React, { useState, useEffect } from "react";
import fnc from '../mymod/commFunction';
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux';
import { setLessonDate, setIsModal, setLmsListCode } from '../reduxToolkit/redux';
import HongDtpicker from '../comm/HongDtpicker';
import "react-datepicker/dist/react-datepicker.css";
// import Checkbox from '../comm/CheckboxMui';
import { Checkbox } from '@mui/material';
import ComboboxMui from '../comm/ComboboxMui';
import SmsMultiApp from '../page_sms_multi/SmsMultiApp'

const LmsTecResultAttendByClass = ({kind}) => {

    const dispatch = useDispatch();
    const isModal = useSelector((state) => state.reduxStore.isModal);
    const classCode = useSelector((state) => state.reduxStore.classCode);
    const isRefresh_lmsTecList = useSelector((state) => state.reduxStore.isRefresh_lmsTecList);
    const attendReason = useSelector(state => state.reduxStore.attendReason);

    const [list, setList] = useState([]);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [monthInfo, setMonthInfo] = useState('');
    const [isSelectAll, setIsSelectAll] = useState(false);//체크박스
    const [optionData, setOptionData] = useState([]);
    const [isModal_smsMulti, setIsModal_smsMulti] = useState(false);
    const [title, setTitle] = useState('');
    const monthInterval = 3;
    const [list_sms, setList_sms] = useState([]);

    useEffect(()=> {
      setOptionData(attendReason);
    }, []);

   
    useEffect(() => {
      onMoveMonth(fnc.getFirstDayOfMonth(new Date(),+1), - monthInterval)
      fncSelect_list();
    }, [classCode]);

    useEffect(() => {
      fncSelect_list();
      const today = fnc.fncDate();
      const weekday = fnc.getWeekDay(today);
      setMonthInfo(`${today} (${weekday})`);
  
    }, [startDate, endDate]);
  
    
  function fncSelect_list() {
    const acaCode = fnc.getCookie('acaCode');
    const stCode = fnc.getCookie('stCode');
    
    fnc.sendAxios('/select/lmsTecResult/attendByClass', 
          { acaCode, classCode, kind, startDate, endDate }, (res) => {
      if (res && Array.isArray(res)) { 
        setList(getRecords(res));

      } else {
        console.log(res,"kuesbLmsTecResultRoutes/select/lmsTecResult/attendByClass");
      }
    });
  }

  
  function getRecords(res) {
    let records = [];
    for (let i = 0; i < res.length; i++) {      
        const snoSt= res[i]["snoSt"];
        const lessonDate= res[i]["lessonDate"];//list 코드 parent Code로 사용
        const stCode = res[i]["stCode"];
        const name = res[i]["name"];
        let hp = res[i]["hp"];
        hp=fnc.formatPhoneNumber(hp);
        let hp_parent = res[i]["hp_parent"];
        hp_parent=fnc.formatPhoneNumber(hp_parent);
        const classCode = res[i]["classCode"];
        const className = res[i]["className"];
        const kind = res[i]["kind"];
        let checkedynSt = res[i]["checkedynSt"];
        checkedynSt = fncCheckedynSt(checkedynSt);
        let eDate = res[i]["eDate"];
        const confirmed = res[i]["confirmed"];
        const weekDay = fnc.getWeekDay(lessonDate);
        const isChecked = false;
        const reason = res[i]["reason"];

        records.push({ snoSt, lessonDate, weekDay, stCode, name, hp, hp_parent, classCode, className, kind, checkedynSt, eDate, confirmed, isChecked, reason });
    }
    return records;
  }

  function fncCheckedynSt(checkedynSt) {
    switch(checkedynSt) {

      case 'Y':
        return '출석';
        break;  
    
      case 'L':
        return '지각';
        break;
      case 'N':
        return '결석';
        break;
  
      default:
        return '-';
        break;
  
    }
  }
  
  
  function onRefresh() {
    if (isButtonDisabled) return; // 버튼이 비활성화되어 있는 경우 아무것도 하지 않음
    fncSelect_list();
    // 버튼 비활성화 및 일정 시간 후 재활성화
    setIsButtonDisabled(true);
    setTimeout(() => setIsButtonDisabled(false), 2000); // 2초 후 버튼 재활성화
  }

//------------------------------------------

  function onClickCheckedynSt(item, index) {//출결 변경
    const nameSt = item.name;
    if (item.confirmed == 'Y') {
      const rtn = window.confirm(`확정된 학생입니다. \n${nameSt}을 수정하시겠습니까?`);
      if (!rtn) return;
    }

    const newList = [...list];
    newList[index].checkedynSt = newList[index].checkedynSt || '결석'; // 기본 값 설정

    switch(newList[index].checkedynSt) {
      case '출석':
        newList[index].checkedynSt = '지각';
        fncUpdate_attend(item.snoSt, '지각');
        break;
      case '지각':
        newList[index].checkedynSt = '결석';
        fncUpdate_attend(item.snoSt, '결석');
        break;
      case '결석':
        newList[index].checkedynSt = '-';
        fncUpdate_attend(item.snoSt, '-');
        break;
      case '-':
          newList[index].checkedynSt = '출석';
          fncUpdate_attend(item.snoSt, '출석');
          break;
      default:
        console.log(`Unknown status: ${newList[index].checkedynSt}`);
    }
    setList(newList);
  }

  function onClickConfirmed(item, index) {//확정 변경
    const newList = [...list];
    newList[index].confirmed = newList[index].confirmed || ''; // 기본 값 설정
    switch (newList[index].confirmed) {
      case '':
        newList[index].confirmed = 'Y';
        fncUpdate_confirmed(item.snoSt, 'Y')
        break;
      case 'Y':
        newList[index].confirmed = '';
        fncUpdate_confirmed(item.snoSt, '')
        break;
      default:
        console.log(`Unknown status: ${newList[index].confirmed}`);
    }
    
    setList(newList);
  }


  
  function fncUpdate_attend(snoSt, checkedynSt) {
    switch (checkedynSt) {
      case '출석':
        checkedynSt = 'Y';
        break;
      case '결석':
        checkedynSt = 'N';
        break;
      case '지각':
        checkedynSt = 'L';
        break;
      case '-':
          checkedynSt = '-';
          break;
    }

    fnc.sendAxios('/update/lmsTecResult/learningSituation_st_attend', { snoSt, checkedynSt }, (res) => {
      if (res) { 
        console.log(res, 'res');
      } else {
        console.log(res,"update/lmsTecResult/learningSituation_st_attend");
      }
    });
  }

  
  function fncUpdate_confirmed(snoSt, confirmed) {//출결 확정

    fnc.sendAxios('/update/lmsTecResult/learningSituation_st_comfirmed', { snoSt, confirmed }, (res) => {
      if (res) { 
        // console.log(res, 'res');
      } else {
        console.log(res,"update/lmsTecResult/learningSituation_st_comfirmed");
      }
    });
  }


  const onMoveMonth = (currDate, monthCnt) => {//dtp
    
    const newStartDate = fnc.getFirstDayOfMonth(currDate, monthCnt);
    const newEndDate = fnc.getLastDayOfMonth(currDate, monthCnt + (Math.abs(monthCnt) - 1) );

    setStartDate(newStartDate);
    setEndDate(newEndDate);
  };



  
   //---------------------------checkbox
   function handleCheckboxChange(event, index) {
    const isChecked = event.target.checked;
    // console.log(isChecked, 'isChecked');
    const newList = [...list];
    newList[index].isChecked = isChecked;
    setList(newList);
 
  // 모두 체크되었는지 확인하여 헤더 체크박스 상태 업데이트
  const allChecked = newList.every(item => item.isChecked);
  setIsSelectAll(allChecked);
  }

  function handleSelectAllChange() {

    const newList = list.map(item => ({...item, isChecked: !isSelectAll }));
    setList(newList);
    setIsSelectAll(!isSelectAll);
  }//checkbox END

  
  const handleOptionChange = (event, index) => {
    const snoSt = list[index].snoSt;
    const reason = event.target.value;
    fncUpdate_reason(snoSt, reason, index);
  };

  
  function fncUpdate_reason(snoSt, reason, index) {
  
    fnc.sendAxios('/update/lmsTecResult/learningSituation_st_reason', { snoSt, reason }, (res) => {
      if (res) { 
        //성공하면 리스트 갱신
        const newList = [...list];
        newList[index].reason = reason;
        setList(newList);

      } else {
        console.log(res,"update/lmsTecResult/learningSituation_st_reason");
      }
    });
  }

  //-------------------------------------멀티전송
  function onSendMulti() {
    setTitle('문자전송 (출결)');
    const newList = getRecords_sms(list);
    setList_sms(newList);
    setIsModal_smsMulti(true);

  }


  const getRecords_sms = (list) => {

    return list.map(({stCode, name, hp, hp_parent, isChecked, lessonDate, checkedynSt, reason }) => {

      let content = '';
      if (checkedynSt === '출석') {
        content = `[${lessonDate}] 수업에 출석하였습니다.`;
      } else if (checkedynSt === '결석') {
        const newReason = reason ? `${reason}로 인해`: '';
        content = `[${lessonDate}] 수업에 ${newReason} 결석하였습니다.`;
      } else if (checkedynSt === '지각') {
        content = `[${lessonDate}] 수업에 지각하였습니다.`;
      } else {
        content = ``;
      }

      const byte = fnc.getByte(content);

      return { isChecked, stCode, name, hp, hp_parent, content, byte };
    });
  };

    //========================================================
    return (

      <div className="LmsTecResultAttendByClass">
        <div className="wrap-main">
          <section className="section-main">
            <table className="table-hong table-main">
              <thead>
                <tr>
                  <th>No</th>
                  <th> <Checkbox    
                        className="custom-checkbox"
                        checked={isSelectAll}
                        onChange={handleSelectAllChange} 
                    />
                  </th>
                  <th>수업일</th>
                  <th>성명</th>
                  <th>HP</th>
                  <th>출결</th>
                  <th>결석사유</th>
                  <th>확정</th>
                  {/* <th>수정일</th>        */}
                </tr>
              </thead>

              <tbody>
                  {list && list.map((item, index) => (
  
                      <tr key={index}>  
                        <td>{index+1}</td>
                        
                        <td>
                            <Checkbox
                            className="custom-checkbox"
                            checked={item.isChecked}
                            onChange={(event) => handleCheckboxChange(event, index)} />
                        </td>

                        <td>{item.lessonDate} ({item.weekDay})</td>
                        <td>{item.name}</td>
                        <td>{item.hp}</td>
                        <td className={
                          item.checkedynSt == '결석' ? 'attendRed': 
                          item.checkedynSt == '지각' ? 'attendBlue':''} 
                          onClick={() => onClickCheckedynSt(item, index)}>
                            {item.checkedynSt}
                        </td>
                        <td>
                           <ComboboxMui
                              label=""
                              value={item.reason || ''}
                              onChange={(event) => handleOptionChange(event, index)}
                              options={optionData}
                            />

                        </td>
 
                        <td onClick={() => onClickConfirmed(item, index)}>{item.confirmed}</td>
                        {/* <td>{item.eDate}</td> */}
                        
                      </tr>
                  ))}
            
                </tbody>
            </table>
          </section>
      
        </div>

        <section className='section-menu'>

          {/* <p className='monthInfo'>{monthInfo}</p> */}
          <HongDtpicker selectedDate={startDate} onDateChange={(date) => setStartDate(date)} />
     
          <Button className='btnRefresh h-btn-sky' onClick={onRefresh} disabled={isButtonDisabled}> 
            <i className="fas fas fa-sync"></i> 
            새로고침
          </Button>

          <Button className='btnSendSms h-btn-red' onClick={onSendMulti}> 
                  <i class="fa-solid fa-mobile-retro"></i> 문자전송
          </Button>

          </section>

         {isModal_smsMulti && <S.Modal_fullScreen>
            <SmsMultiApp title={title} setIsModal_smsMulti={setIsModal_smsMulti} list_sms={list_sms} setList_sms={setList_sms} />
          </S.Modal_fullScreen> }

      </div>
    );

    
}

export default LmsTecResultAttendByClass;